<template>
    <div class="newslist">
        <head-menu current="1" />
        <div class="content">
            <p class="title">全部资讯</p>
            <div>
                <news-list :news="news" />
            </div>
        </div>
        <page-contronl :total="total"  :display="display" :currentPage="currentPage" :pagegroup="pagegroup" @pagechange="pagechange"/>
        <footer-links />
    </div>
</template>
<script>
import HeadMenu from '../../../common/head-menu';
import FooterLinks from '../../../common/footer-links';
import NewsList from '../../../common/news-list';
import PageContronl from '../../../common/page';
export default {
    components:{
        HeadMenu,
        NewsList,
        FooterLinks,
        PageContronl
    },
    data()
    {
        return {
            news:[],
            total:0,
            display:0,
            currentPage:1,
            pagegroup:0
        }
    },
    methods:{
        initNews(page){
            this.$http.get('/api/news/list?page='+page).then(response => {
            let status=response.status;
            let message=response.message;
            if(status === 200){
                console.log(response.data);
                this.news = response.data.data.list; 
                this.currentPage = response.data.data.page.current;
                this.total = response.data.data.page.total;
                this.display = response.data.data.page.size;
                this.pagegroup = response.data.data.page.pages;
            }
        
            }, response => {
                alert("数据加载失败请重试");
            });
        },
        pagechange(current){
            this.initProjects(current);
        }
    },
    created(){
        this.initNews(1);
    }
}
</script>
<style lang="less">
.newslist{
    .content{
        padding: 20px 80px;
        .title{
            max-width: 1320px;
            margin: 0 auto;
            font-size: 22px;
        }
    }

    .newsHead{
        display: none;
    }

    .linksHead{
        display: none;
    }

    .footer ul{
        display: none;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/activity/newslist/index.vue